import { render, staticRenderFns } from "./CommitHistoryButton.vue?vue&type=template&id=7e9e353d&scoped=true"
import script from "./CommitHistoryButton.vue?vue&type=script&lang=js"
export * from "./CommitHistoryButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9e353d",
  null
  
)

export default component.exports